// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"ReportsList_ProseMirror__20WYl","reportsList":"ReportsList_reportsList__lJf7L","reportsList__item":"ReportsList_reportsList__item__3Ei-5"};